<template>
  <div id="dashboard-index">
    <Breadcrumbs
      :breadcrumbs="[
        { title: this.$t(`menu.${this.serviceSlug}`) },
        { title: this.$t('check-up_plus.dashboard'), disabled: true }
    ]">

      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Filters
          :isActive="showFilters"
          :active-filters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>

    </Breadcrumbs>


    <div class="text-center" v-if="isLoading">
      <LoadingAnimation></LoadingAnimation>
    </div>
    <div v-else>
      <div class="row mt-2 no-gutters evollu-form" v-if="showFilters">
        <div class="row">
          <div class="col-12 col-md-4">
            <range-date-picker
              id="statistics-date-range"
              :label="$t('statistics2.hear.sublabels.period')"
              v-model="filters.dateRange"
              placeholder="---"
              :config="{ maxInterval: { value: 6, unit: 'months' } }"
              :clearable="false"
            >
            </range-date-picker>
          </div>

          <div class="col-12 col-md-4">
            <label class="form-label">
              {{ $t('menu.facilities') }}
            </label>
            <multiselect
              id="entities-filter"
              v-model="filters.entities"
              :options="readableFacilities"
              track-by="id"
              :customLabel="formatedEntityLabel"
              :placeholder="readableFacilities.length ? $t('dashboard_new_evollu.values.several_facilities') : $t('dashboard_new_evollu.values.empty_facilities')"
              :allow-empty="true"
              :multiple="false"
              :internal-search="true"
              :disabled="!readableFacilities.length"
            >

              <template slot="clear">
                <span class="multiselect__clear" v-if="filters.entities.length"
                  @mousedown.prevent.stop="filters.entities = []"></span>
              </template>
            </multiselect>
          </div>
        </div>
      </div>


      <GraphsDashboard
        class="mt-4"
        :filters="filters"
      />

    </div>


  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import GraphsDashboard from "@/components/checkup_plus/dashboard/GraphsDashboard";
import LoadingAnimation from "@/components/users/components/Helpers/LoadingAnimation";
import RangeDatePicker from "@/components/common/RangeDatePicker";
import Multiselect from 'vue-multiselect'
import MultiselectLabelFormatter from "@/mixins/MultiselectLabelFormatter";
import ClustersAndEntitiesMixin from "@/mixins/ClustersAndEntitiesMixin";
import Filters from '@/components/common/Filters'
import LocalStorageHelper from "@/local-storage/LocalStorageHelper";
import {CHECkUP_PLUS_PATIENTS_TABLE} from "@/local-storage/LocalStorageKeys";

const DASHBOARD_INFO_TYPE = 110;

export default {
  mixins: [
    MultiselectLabelFormatter,
    ClustersAndEntitiesMixin
  ],
  components: {RangeDatePicker, LoadingAnimation, GraphsDashboard, Breadcrumbs, Multiselect, Filters},
  props: {
    component: {
      type: Object,
      required: true,
    },
    serviceSlug: {
      type: String,
      required: true
    }
  },
  async created() {
    this.isLoading = true
    await this.loadLocalStorage()
    this.isLoading = false
  },
  data: function () {
    return {
      isLoading: false,
      showFilters: true,
      activeFilters: 0,
      entityOptions: [],
      filters: {
        entities: [],
        facilities: [],
        dateRange: {
          start: this.moment().startOf('month').format('YYYY-MM-DD'),
          end: this.moment().endOf('month').format('YYYY-MM-DD'),
        }
      },
    }
  },
  methods: {
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    loadLocalStorage: function () {
      return new Promise((resolve, reject) => {
        const state = LocalStorageHelper.get(CHECkUP_PLUS_PATIENTS_TABLE)
        if (state !== null) {
          this.filters = {
            ...this.filters,
            ...state
          }
        }
        resolve()
      })
    },
  },
  computed: {
    checkupPlusService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.onecare_server) || null
    },
    readableEntities: function () {
      if (!this.checkupPlusService) {
        return []
      }
      let permissions = this.checkupPlusService.user_permissions.filter(
        p => p.info_type === DASHBOARD_INFO_TYPE && p.access_type >= this.$store.state.accessTypes.READ
      )

      if (permissions.some(p => p.entity_id === null)) {
        return [...this.checkupPlusService.entities]
      } else {
        return this.checkupPlusService.entities.filter(entity => permissions.some(p => p.entity_id === entity.id))
      }
    },
    readableFacilities: function () {
      if (!this.readableEntities.length) {
        return []
      }
      return this.readableEntities.map(entity => entity.facilities).flat()
    },
  }
}
</script>

<style scoped>

</style>
